import { clearImageTimer } from '@/helpers/mediaUtils';
import { releaseMediaSrcIn } from '@/helpers/deferredMediaSrc';

export const closeModal = () => {
  clearImageTimer();
  setTimeout(() => {
    const modal = document.querySelector('.storeeel-modal');
    const previousBodyOverflow = modal?.dataset?.storeeelPreviousBodyOverflow ?? '';
    document.body.style.overflow = previousBodyOverflow;
    if (modal) {
      // DOM から外すだけでは取得中の動画の通信が残ることがあるため、先に解放する
      releaseMediaSrcIn(modal);
      const modalHost = modal.getRootNode?.()?.host;
      if (modalHost?.dataset?.storeeelModalHost === 'true') {
        modalHost.remove();
      } else {
        modal.remove();
      }
    }
  }, 0);
};
